import '../utils/stringPrototypeExtensions';

import '@egjs/flicking-plugins/dist/arrow.min.css';
import '@egjs/flicking-plugins/dist/pagination.min.css';
import '@egjs/react-flicking/dist/flicking.css';
import '@netfront/ekardo-content-library/dist/esm/css/index.css';
import '@netfront/ui-library/dist/esm/css/index.css';
// import '@netfront/ui-library/dist/css/_datepicker.css';
import '@netfront/ui-library/dist/css/global.css';
import '@netfront/ui-library/dist/css/helpers.css';

import 'react-circular-progressbar/dist/styles.css';



import '../styles/cms.css';
import '../styles/pages.css';
import '../styles/globals.css';
import '../styles/theme.css';
import '../styles/utils.css';

import { ApolloClientsProvider } from '@netfront/apollo-providers';
import { getAccessTokenCookie, getRefreshTokenCookie, getUserDataCookie } from '@netfront/common-library';
import { ContentPageProvider, useGoogleAnalytics } from '@netfront/ekardo-content-library';
// import { Icons } from '@netfront/ui-library';
import { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';

import { getLoginRoute } from '../hooks/useProtectedRoute/useProtectedRoute.helpers';

function AppContent({ Component, pageProps }: AppProps) {
    const { events } = useRouter();
    const { trackPageView, trackUser } = useGoogleAnalytics();

    useEffect(() => {
        const handleRouteChange = (url: string) => {
            trackPageView(url);
            trackUser();
        };
        // When the component is mounted, subscribe to router changes
        // and log those page views
        events.on('routeChangeComplete', handleRouteChange);

        // If the component is unmounted, unsubscribe
        // from the event with the `off` method
        return () => {
            events.off('routeChangeComplete', handleRouteChange);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [events]);

    return (
        <ContentPageProvider>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Component {...pageProps} />
        </ContentPageProvider>
    );
}

function App(props: AppProps) {
    const { push } = useRouter();

    const onUnauthenticated = () => {
        /*
         * A single GraphQL request's token refresh can lose a race against a
         * concurrent refresh (e.g. Next.js middleware, or another in-flight
         * request) that rotates the same single-use refresh token first.
         * That doesn't mean the session is actually invalid, so re-check
         * live cookie state before redirecting - if valid tokens are
         * present, the other refresh already won and the session is fine.
         */
        const hasValidSession = Boolean(getAccessTokenCookie() && getRefreshTokenCookie() && getUserDataCookie());

        if (hasValidSession) {
            return;
        }

        void push(getLoginRoute());
    };

    return (
        <ApolloClientsProvider
            options={{
                projectId: process.env.REACT_APP_PROJECT_ID ?? '',
                onUnauthenticated,
                endpointSource: {
                    source: 'environment variables',
                },
            }}
        >
            <div id="root">
                <div>
                    <Toaster position="top-center" reverseOrder={false} />
                </div>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <AppContent {...props} />
            </div>
        </ApolloClientsProvider>
    );
}

// eslint-disable-next-line import/no-default-export
export default App;
